module.exports = __webpack_public_path__ + "img/choose-municipality.17bc685d.jpg";